module.exports = __webpack_public_path__ + "static/media/all-user-active-2.ab4a6d2c.svg";